/* Laadpaal one-product shop: kleine interacties, geen afhankelijkheden */

(() => {
  // Laadpercentage in de hero loopt mee met de ring-animatie
  const pct = document.querySelector('[data-charge-pct]');
  const bar = document.querySelector('[data-charge-bar]');
  if (pct && bar && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let value = 20;
    let timer = null;
    const start = () => {
      if (timer || document.hidden) return;
      timer = setInterval(() => {
        value = value >= 80 ? 20 : value + 1;
        pct.textContent = `${value}%`;
        bar.style.width = `${value}%`;
      }, 140);
    };
    const stop = () => { clearInterval(timer); timer = null; };
    let visible = true;
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; visible ? start() : stop(); }).observe(pct);
    document.addEventListener('visibilitychange', () => (document.hidden || !visible ? stop() : start()));
  }

  // Fotogalerij: eerste miniatuur is de laadpaal-stage, de rest zijn foto's
  const galleryMain = document.querySelector('[data-gallery-main]');
  if (galleryMain) {
    const stage = galleryMain.querySelector('[data-stage]');
    const photo = galleryMain.querySelector('.gallery__photo') || galleryMain.querySelector('img');
    const video = galleryMain.querySelector('.gallery__video');
    document.querySelectorAll('[data-gallery-thumbs] button').forEach((btn, i, all) => {
      btn.addEventListener('click', () => {
        const showStage = btn.hasAttribute('data-stage-thumb');
        const showVideo = !!btn.dataset.video && video;
        if (stage) stage.hidden = !showStage;
        if (video) {
          video.hidden = !showVideo;
          if (showVideo) {
            if (video.src !== btn.dataset.video) video.src = btn.dataset.video;
            video.play().catch(() => {});
            if (photo) photo.hidden = true;
          } else {
            video.pause();
          }
        }
        if (showVideo) {
          // video staat al
        } else if (!showStage && photo) {
          photo.removeAttribute('srcset');
          photo.src = btn.dataset.full;
          photo.hidden = false;
        } else if (photo && stage) {
          photo.hidden = true;
        }
        all.forEach((b) => b.classList.toggle('is-active', b === btn));
      });
    });
  }

  // Voorraadteller telt op als hij in beeld komt
  document.querySelectorAll('[data-countup]').forEach((el) => {
    const target = Number(el.textContent.trim());
    if (!target || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    el.textContent = '0';
    const run = () => {
      const t0 = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - t0) / 1400);
        el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) { run(); obs.disconnect(); }
    }).observe(el);
  });

  // Scroll-tour: de stap in het midden van het scherm bepaalt wat er oplicht
  const tourStage = document.querySelector('[data-tour-stage]');
  if (tourStage) {
    const steps = document.querySelectorAll('[data-tour-step]');
    const kwh = tourStage.querySelector('[data-tour-kwh]');
    let counted = false;
    const countKwh = () => {
      if (counted || !kwh) return;
      counted = true;
      const t0 = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - t0) / 1600);
        kwh.textContent = (38.4 * (1 - Math.pow(1 - t, 3))).toFixed(1).replace('.', ',');
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    // De stap die het midden van het scherm raakt (of er het dichtst bij zit) is actief
    let current = null;
    const pick = () => {
      const mid = innerHeight / 2;
      let best = null; let dist = Infinity;
      steps.forEach((s) => {
        const r = s.getBoundingClientRect();
        const d = r.top <= mid && r.bottom >= mid ? 0 : Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid));
        if (d < dist) { dist = d; best = s; }
      });
      if (!best || best === current) return;
      current = best;
      steps.forEach((s) => s.classList.toggle('is-active', s === best));
      tourStage.dataset.focus = best.dataset.tourStep;
      if (best.dataset.tourStep === 'meter') countKwh();
    };
    let ticking = false;
    addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { pick(); ticking = false; });
    }, { passive: true });
    pick();
  }

  // Aantal-knoppen
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = Number(input.value || 1) + Number(btn.dataset.step);
        input.value = Math.max(1, next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  });

  // Winkelwagen: aantal aangepast, dan direct bijwerken
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    let timer;
    cartForm.addEventListener('input', (e) => {
      if (e.target.name !== 'updates[]') return;
      clearTimeout(timer);
      timer = setTimeout(() => cartForm.submit(), 600);
    });
  }

  // Staffel: prijs per stuk en totaal rekenen live mee met het aantal
  const box = document.querySelector('[data-buybox]');
  if (box && box.dataset.basePrice) {
    const base = Number(box.dataset.basePrice);
    const eur = (cents) => (cents / 100).toLocaleString('nl-NL', {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2,
    });
    const each = (discountEur, discountPct = 0) => Math.round(base * (1 - discountPct / 100)) - discountEur * 100;
    const radios = [...box.querySelectorAll('[data-tiers] input')];
    const qty = box.querySelector('[data-qty] input');
    const total = box.querySelector('[data-total]');

    radios.forEach((r) => {
      r.closest('.tier').querySelector('[data-tier-price]').textContent = `${eur(each(Number(r.dataset.discount), Number(r.dataset.discountPct || 0)))} p/st`;
      r.addEventListener('change', () => { qty.value = r.value; render(); });
    });

    const render = () => {
      const q = Math.max(1, Number(qty.value) || 1);
      const tier = radios.filter((r) => Number(r.value) <= q).pop();
      if (tier) tier.checked = true;
      const price = tier ? each(Number(tier.dataset.discount), Number(tier.dataset.discountPct || 0)) : base;
      document.querySelectorAll('[data-price-each]').forEach((el) => { el.textContent = eur(price); });
      if (total) total.textContent = q > 1 ? `· totaal ${eur(price * q)} voor ${q} stuks` : '';
    };
    if (qty) qty.addEventListener('input', render);
    // Zelfde prijsnotatie in de sticky balk als in de rest van de pagina
    document.querySelectorAll('.sticky-buy [data-price-each]').forEach((el) => { el.textContent = eur(base); });
  }

  // Verzendaftelling: tot de besteltijd vandaag, anders de eerstvolgende werkdag
  const cutoff = document.querySelector('[data-cutoff]');
  if (cutoff) {
    const hour = Number(cutoff.dataset.cutoff);
    const days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
    const tick = () => {
      const now = new Date();
      const day = now.getDay();
      const end = new Date(now); end.setHours(hour, 0, 0, 0);
      const weekday = day >= 1 && day <= 5;
      if (weekday && now < end) {
        const mins = Math.ceil((end - now) / 60000);
        const h = Math.floor(mins / 60), m = mins % 60;
        cutoff.textContent = ` · bestel binnen ${h ? `${h}u ` : ''}${m}m, ${day === 5 ? 'dan gaat hij vandaag de deur uit' : 'dan heb je hem morgen in huis'}`;
      } else {
        let next = (day + 1) % 7;
        while (next === 0 || next === 6) next = (next + 1) % 7;
        cutoff.textContent = next === (day + 1) % 7 ? ' · morgen verzonden' : ` · ${days[next]} verzonden`;
      }
    };
    tick();
    setInterval(tick, 30000);
  }

  // Laadtijdrekenaar
  const calc = document.querySelector('[data-calc]');
  if (calc) {
    const chargerKw = Number(calc.dataset.chargerKw) || 11;
    const kmPerKwh = 100 / (Number(calc.dataset.kwhPer100) || 17);
    const out = (name) => calc.querySelector(`[data-out="${name}"]`);
    const fmt = (n, d = 1) => n.toLocaleString('nl-NL', { maximumFractionDigits: d });

    const update = () => {
      const grid = Number(calc.querySelector('input[name="grid"]:checked').value);
      const car = Number(calc.querySelector('input[name="car"]:checked').value);
      const battery = Number(calc.querySelector('input[name="battery"]:checked').value);
      const kw = Math.min(chargerKw, grid, car);
      const hours = (battery * 0.6) / kw; // 20% naar 80%

      out('kmh').textContent = Math.round(kw * kmPerKwh);
      out('kw').textContent = `${fmt(kw)} kW`;
      out('hours').textContent = `${fmt(hours)} uur`;
      out('night').textContent = `${Math.round(kw * 8 * kmPerKwh)} km`;

      const byGrid = kw === grid && grid < chargerKw;
      const byCar = kw === car && car < chargerKw;
      const limiter = byGrid && byCar ? 'je huisaansluiting en de lader in je auto'
        : byGrid ? 'je huisaansluiting' : byCar ? 'de lader in je auto' : null;
      out('verdict').textContent = hours <= 8
        ? `In één nacht van 20 naar 80%.${limiter ? ` De grens ligt bij ${limiter}.` : ''}`
        : `Dat past niet in één nacht. De grens ligt bij ${limiter || 'het vermogen'}.`;
    };
    calc.addEventListener('change', update);
    update();
  }

  // Sticky koopbalk zolang de koopknop niet in beeld is (ook boven de vouw op mobiel)
  const sticky = document.querySelector('[data-sticky-buy]');
  const buybox = document.querySelector('[data-buybox]');
  const anchor = buybox && (buybox.querySelector('.buybox__row') || buybox);
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }).observe(anchor);
  }
})();
